import { Observable } from 'rxjs';
import { CanDeactivateFn } from '@angular/router';

export interface ICanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

export const canDeactivateGuardFn: CanDeactivateFn<ICanComponentDeactivate> = (component: ICanComponentDeactivate): boolean | Observable<boolean> | Promise<boolean> => {
  return component.canDeactivate ? component.canDeactivate() : true;
}
